import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ProteinDetailService } from '../services/protein-detail.service';

@Component({
  selector: 'app-protein-detail',
  templateUrl: './protein-detail.component.html',
  styleUrls: ['./protein-detail.component.css']
})
export class ProteinDetailComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private proteinDetailService: ProteinDetailService
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.protein_id = params.get('logic_id');
      this.proteinDetailService.getProteinDetail(this.protein_id).subscribe(params=>{
        this.detail_data = params
      });
      this.loading = false;
    })
  }

  
  protein_id;
  loading = true;
  detail_data = null;
  objectKeys;


  getPropertiesKeys(tabValue){
    this.objectKeys = Object.keys(tabValue)
  }


}
